module.exports = __webpack_public_path__ + "static/work_NOTD-adaa224398cbf038a150fcd8e490c8e4.mp4";